module.exports = __webpack_public_path__ + "static/media/print-packing-slip.83943497.jpeg";